export default "__VITE_ASSET__CoLHrda$__"